import React from "react";
import Immutable from "immutable";
import { singleton } from "logic/singleton";
const MessageFavoriteFieldsContext = React.createContext({
  favoriteFields: [],
  saveFavoriteField: () => {
  },
  messageFields: Immutable.List([]),
  toggleField: () => {
  },
  message: void 0,
  editableStreams: [],
  setFieldsIsPending: false,
  initialFavoriteFieldsByStream: {}
});
export default singleton("contexts.MessageFavoriteFieldsContext", () => MessageFavoriteFieldsContext);
